'use strict';

angular.module('far.camp')
    .controller('CampRoutesController', function ($log,
                                                  $http,
                                                  $window,
                                                  $timeout,
                                                  $q,
                                                  pagination) {
        var vm = {
            constructor: constructor,
            pagination: pagination('events', {next: nextPage, itemsOnPage: 4}),
            filter: {
                period: 'all',
                eventData: null
            },
            campId: null,
            personalEvents: [],
            events: [],
	    getMountainRouteUrl: function (route) {
		return Routing.generate('page_mountainroute_index', {'id': route.id});
	    },
	    getPeaksStringForRoute: function (route) {
                return route.mountain_peaks.map(function(peak) {
                        var _return = [];

                        if ( peak.name ) {
                                _return.push(peak.name);
                        }

                        return _return.join(', ');
                }).join(' - ');
	    },
	    getHeightStringForRoute: function (route) {
		var _return = [];
                route.mountain_peaks.map(function(peak) {
                        _return.push(peak.height);
                });
                if(_return.length > 1) {
                        return '';
                }
                return _return[0];
	    }
        };

        function constructor(campId) {
            vm.campId = campId;
            vm.pagination.clear();
        }

        function nextPage(page, count) {
            var eventData = {};

            if (vm.filter.eventData) {
                eventData[vm.filter.eventData] = true;
            }

            return $http.get(Routing.generate('api_entities_get_mountainroutes', {
                camp_id: vm.campId,
                offset: (page - 1) * count,
                limit: count
            })).then(function (response) {
                var items = [];
                vm.totalPages = Math.ceil(response.headers('X-Total-Count') / count);

                angular.forEach(response.data, function (item) {
                    items.push(item[0]);
                });

                return items;
            }).catch(function (response) {
                $log.error(response);
                return $q.reject(response);
            });
        }

        return vm;
    });
